import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi'; // Ícones para abrir/fechar o menu

function Navbar({ onLogout }) {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false); // Controle de visibilidade do menu

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };

    return (
        <div>
            {/* Barra de navegação no topo */}
            <div className="fixed top-0 left-0 w-full bg-gray-800 text-white z-50 shadow-md">
                <div className="flex justify-between items-center p-1">
                    <h3 className="pl-3 text-2xl font-serif">Vexor Finance</h3>

                    {/* Botão de menu (visível apenas em mobile) */}
                    <button
                        className="lg:hidden p-4 text-white"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
                    </button>

                    {/* Navegação - itens visíveis em desktop */}
                    <nav className="hidden lg:flex gap-6">
                        <Link to="/dashboard" className="py-2 px-4 rounded hover:bg-gray-700 transition">
                            Dashboard
                        </Link>
                        <Link to="/projects" className="py-2 px-4 rounded hover:bg-gray-700 transition">
                            Projetos
                        </Link>
                        <Link to="/clients" className="py-2 px-4 rounded hover:bg-gray-700 transition">
                            Clientes
                        </Link>
                        <Link to="/products" className="py-2 px-4 rounded hover:bg-gray-700 transition">
                            Estoque
                        </Link>
                        <Link to="/generate-legal" className="py-2 px-4 rounded hover:bg-gray-700 transition">
                            Jurídico
                        </Link>
                        <Link to="/generate-quote" className="py-2 px-4 rounded hover:bg-gray-700 transition">
                            Gerar Orçamento
                        </Link>
                    </nav>
                    {/* Botão Logout - Visível em todos os tamanhos */}
                    <div className="p-4">
                        <button
                            onClick={handleLogout}
                            className="w-full py-1 px-4 bg-red-600 rounded hover:bg-red-700 transition"
                        >
                            Logout
                        </button>
                    </div>
                </div>

                {/* Menu hambúrguer visível apenas em mobile */}
                {isOpen && (
                    <div className="lg:hidden bg-gray-800 text-white p-4">
                        <nav className="flex flex-col gap-4">
                            <Link to="/dashboard" className="py-2 px-4 rounded hover:bg-gray-700 transition" onClick={() => setIsOpen(false)}>
                                Dashboard
                            </Link>
                            <Link to="/projects" className="py-2 px-4 rounded hover:bg-gray-700 transition" onClick={() => setIsOpen(false)}>
                                Projetos
                            </Link>
                            <Link to="/clients" className="py-2 px-4 rounded hover:bg-gray-700 transition" onClick={() => setIsOpen(false)}>
                                Clientes
                            </Link>
                            <Link to="/products" className="py-2 px-4 rounded hover:bg-gray-700 transition" onClick={() => setIsOpen(false)}>
                                Estoque
                            </Link>
                            <Link to="/generate-legal" className="py-2 px-4 rounded hover:bg-gray-700 transition" onClick={() => setIsOpen(false)}>
                                Jurídico
                            </Link>
                            <Link to="/generate-quote" className="py-2 px-4 rounded hover:bg-gray-700 transition" onClick={() => setIsOpen(false)}>
                                Gerar Orçamento
                            </Link>
                        </nav>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Navbar;
